/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React from "react";
import Button from "../GlobalComponents/Button";

const Info = () => (
  <div css={styles} className="info">
    <h1>
      LIFE <span>LIGHT</span> FITNESS 
    </h1>
    <h2>NITTAMBUWA & PASYALA</h2>
    <br/>
    {/* <Button className="mt-4" text="BECOME A MEMBER" /> */}
    <div className="header__button">
                <button>Join Now</button>
            </div>
  </div>
);

const styles = css`
  width: 100%;
  max-width: 900px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  text-align: center;
  color: #fff;
  p {
    font-size: 17px;
    line-height: 1;
    font-weight: 900;
    letter-spacing: 1.2px;
  }
  h1 {
    font-size: 90px;
    line-height: 1;
    font-weight: 900;
    margin: 36px 0;
    span {
      color: #dd3333;
    }
  }
  .btn {
    padding: 14px 16px;
  }
  .header__button{
    display: flex;
    justify-content: center;
    margin-top: 50px;
    
}
.header__button button{
    padding: 15px 40px;
    border-radius: 50px;
    border: 2px solid  #dd3333;
    outline: none;
    background: none;
    color: white;
    font-size: 18px;
    text-transform: uppercase;
    cursor: pointer;
    font-weight: bold;
}
  @media (max-width: 1000px) {
    h1 {
      font-size: 42px;
    }
  }
`;

export default Info;
